import Button from "./Button/Index";
import Section from "./Section";
import FormService from "../services/formService";
import { useEffect, useState } from "react";
import {BUTTON_TEXT, ERROR } from "./consts.jsx"
import SecondaryTitle from "./Section/SecondaryTitle";

const InstallTrackingCode = ({ initSettings }) => {
  const formService = new FormService()
  const secondaryTitleText = "Activate tracking code"
  const [loading, setLoading] = useState(false)
  const [installed, setInstalled] = useState(false)
  const [buttonText, setButtonText] = useState(BUTTON_TEXT.ACTIVATE)
  const [errorMessage, setErrorMessage] = useState()
  const [secondaryButtonText, setSecondaryButtonText] = useState(null);

  const setActivated = () => {
    setButtonText(BUTTON_TEXT.ACTIVATED)
    setSecondaryButtonText(BUTTON_TEXT.DEACTIVATE)
  }

  const toggleSuccess = () => {
    setButtonText(BUTTON_TEXT.SUCCESS)
    setTimeout(setActivated, 1000)
  }

  const setError = () => {
    setErrorMessage(ERROR.TRACKING_CODE_ACTIVATION); 
    setButtonText(BUTTON_TEXT.ERROR)
  }

  const toggleDeactivated = () => {
    setButtonText(BUTTON_TEXT.SUCCESS)
    setSecondaryButtonText(null)
    setTimeout(() => setButtonText(BUTTON_TEXT.ACTIVATE), 1000)
  }

  const updateClickFraudCode = async (install = true) => {
    setLoading(true)
    setErrorMessage(null)
    try{
      await formService.updateInstallClickFraud(install);
      initSettings.installClickFraud = install;
      setInstalled(initSettings?.installClickFraud);
      if(install)
        toggleSuccess()
      else{
        toggleDeactivated()
      }
    }
    catch(error){
      setError()
    }
    setLoading(false)
  };

  useEffect(() => {
    setInstalled(initSettings?.installClickFraud)    
    if(initSettings?.installClickFraud)
      setActivated()     
    else{
      setButtonText(BUTTON_TEXT.ACTIVATE)
    }  
    // eslint-disable-next-line
  }, [initSettings]);

  const body =  <>
    <div className="tracking-code-desc">
      The tracking code is essential to analyze user behavior on your website and catch all the fraudsters that come your way! Be sure to install both tracking codes for best
      performance.
    </div>  
    <section className="cc-flex">    
      <Button
        onClick={() => updateClickFraudCode(true)}
        loading={loading}
        content={buttonText}
        errorMessage={errorMessage}
      />
        { 
          secondaryButtonText && 
          <Button 
            onClick={() => updateClickFraudCode(false)}
            content={secondaryButtonText} 
          />
        }  
    </section>
  </>

  const secondaryTitle = <SecondaryTitle checked={installed}  text={secondaryTitleText}/>

  return (
    <Section title="ClickCease Paid Marketing" body={body} secondaryTitle={secondaryTitle}/>   
  );
};
export default InstallTrackingCode;
